import { promotionListHandler, redeemPromotionHandler, promotionDetailHandler ,earnPointsAddFriendHandler} from '@api/promotion-api'
import PromotionStorage from "../storage/promotion.storage";
import router from '../../router';
import { Message } from 'element-ui';
import i18n from '@/helper/i18n'
import store from '@store'

const promotion = {
    namespaced: true,
    state: {
        promotionList: null,
        promotionDetail: PromotionStorage.promotionDetail,
        promotionCode: null,
        defaultPromotionList: null,
        promotionRewardPoint: null,
        dialogRewardPoint: false,
        redeemingAddFriend: PromotionStorage.redeemingAddFriend,
    },
    getters: {
        promotionList(state) {
            return state.promotionList
        },
        promotionDetail(state) {
            return state.promotionDetail
        },
        promotionCode(state) {
            return state.promotionCode
        },
        defaultPromotionList(state) {
            return state.defaultPromotionList
        },
        promotionRewardPoint(state) {
            return state.promotionRewardPoint
        },
        dialogRewardPoint(state) {
            return state.dialogRewardPoint
        },
        redeemingAddFriend(state) {
            return state.redeemingAddFriend
        },
    },
    mutations: {
        SET_PROMOTION_LIST(state, promotionList) {
            state.promotionList = promotionList
            state.defaultPromotionList = promotionList
            state.defaultPromotionList = promotionList
        },
        SET_PROMOTION_DETAIL(state, promotionDetail) {
            state.promotionDetail = promotionDetail
            PromotionStorage.promotionDetail = promotionDetail
        },
        SET_PROMOTION_CODE(state, promotionCode) {
            state.promotionCode = promotionCode
        },
        SET_PROMOTION_FILTER(state, filteredPromotions) {
            state.promotionList = filteredPromotions
        },
        SET_PROMOTION_SORT(state, sortedPromotions) {
            state.promotionList = sortedPromotions
        },
        SET_PROMOTION_REWARD_POINT(state, promotionRewardPoint) {
            state.promotionRewardPoint = promotionRewardPoint
        },
        OPENT_REWARD_POINT_DIALOG(state) {
            state.dialogRewardPoint = true
        },
        CLOSE_REWARD_POINT_DIALOG(state) {
            state.dialogRewardPoint = false
            state.promotionRewardPoint = null
        },
        SET_REDEEMING_ADD_FRIEND(state, data){
            state.redeemingAddFriend = data
            PromotionStorage.redeemingAddFriend = data
        },
        CLEAR_REDEEM_ADD_FRIEND(state){
            state.promotionDetail = null
            state.redeemingAddFriend = null
            PromotionStorage.clearRedeemingAddFriend()
            PromotionStorage.clearPromotionDetail()
        },
    },
    actions: {
        fetchPromotionList: async ({ commit }, branchUUID) => {
            return await promotionListHandler(branchUUID)
                .then(async (response) => {
                    if(response.data.data != null){
                        await commit(
                            'SET_PROMOTION_LIST',
                            response.data.data.promotions,
                        )
                        return
                    }
                    throw 'Not Found promotion info'
                })
                .catch(async (error) => {
                    if (error.response) {
                        if (
                            error.response.data.code == 400 &&
                            error.response.data.responseCode == 'B02'
                        ) {
                            await commit('SET_PROMOTION_LIST', null);
                            throw { isDisableCrm: true };
                        } else {
                            throw error;
                        }
                    } else {
                        throw error;
                    }
                })
        },
        setPromotionDetail: async ({ commit }, promotionDetail) => {
            let moreDetail = await promotionDetailHandler(
                promotionDetail.promotionRefKey,
            )
                .then(async (response) => {
                    if (response.status == 200) {
                        return response.data.data
                    }
                })
                .catch(async (error) => {
                    return false
                })
            if (moreDetail) {
                await commit('SET_PROMOTION_DETAIL', {
                    ...moreDetail,
                    ...promotionDetail,
                })
                router.push({ path: '/promotion-detail' })
            }
        },
        redeemPromotion: async ({ state, commit }, payload) => {
            return await redeemPromotionHandler(payload)
                .then(async (response) => {
                    store.commit(
                        'coupon/SET_COUPON_DETAIL',
                        state.promotionDetail,
                    )
                    store.commit('coupon/SET_COUPON_CODE_VIEW', false)
                    store.commit('coupon/SET_COUPON_CODE', response.data.data)
                    router.push({ name: 'CouponCode' })
                    return response.data.data;
                })
                .catch((error) => {
                    Message.error({
                        duration: 2000,
                        message: i18n.t('store.error-redeem'),
                    })
                    return error;
                })
                .finally(() => {
                    commit('CLEAR_REDEEM_ADD_FRIEND')
                    store.commit('user/CLEAR_LINE_FRIEND_TOKEN');
                })
        },
        earnPointsAddFriend : async ({ commit },payload) => {
            return await earnPointsAddFriendHandler(payload)
                .then(async (response) => {
                    await commit('SET_PROMOTION_REWARD_POINT', response.data)
                    router.push({
                        name: 'Home',
                        params: {
                            restaurant_aliase: store.getters['restaurant/restaurantUUID'],
                            branch_aliase: store.getters['branch/branchUUID'],
                        }, })
                    return response.data.data;
                })
                .catch((error) => {
                    Message.error({
                        duration: 2000,
                        message: i18n.t('store.error-redeem'),
                    })
                    return error;
                }).finally(()=>{
                    commit('CLEAR_REDEEM_ADD_FRIEND')
                    store.commit('user/CLEAR_LINE_FRIEND_TOKEN');
                })
        },
    }
}

export default promotion
